<div class="review light-brown-color border-radius p-15 gap-15 d-flex flex-column justify-content-center">
    <div class="d-flex gap-10 align-items-center">
        <img *ngIf="data.avatarUrl" class="avatar" [src]="data.avatarUrl">
        <div class="d-flex flex-column flex-grow-1">
            <div class="name">{{data.name}}</div>
            <div *ngIf="data.subtitle" class="subtitle">{{data.subtitle}}</div>
        </div>
        <div class="d-flex align-items-center gap-5">
            <span class="review-stars">●</span>
            <span class="review-rate">{{data.rate}}</span>
        </div>
    </div>

    <div class="message">{{data.message}}</div>
</div>